import { RequestStatus } from './requestStatus';

const requestClubs = [
  {
    id: 'vc-pebble-shore',
    name: 'Pebble Shore Country Club',
    city: 'Monterey, CA',
    heroImage: '/img/club613/cover2.jpg',
    blurb: 'Private coastal links, request-only access for Virtus members.',
    windowCopy: 'Typical response within 2 hours · 7:00am – 4:00pm local',
  },
  {
    id: 'vc-laurel-canyon',
    name: 'Laurel Canyon Golf Reserve',
    city: 'Asheville, NC',
    heroImage: '/img/club613/cover3.jpg',
    blurb: 'Mountain parkland course with member-sponsor access.',
    windowCopy: 'Typical response within 4 hours · weekday priority',
  },
  {
    id: 'vc-horizon-dunes',
    name: 'Horizon Dunes Links',
    city: 'East Hampton, NY',
    heroImage: '/img/club613/cover4.jpg',
    blurb: 'Seaside dunes layout with capped weekend tee sheets.',
    windowCopy: 'Typical response within 24 hours',
  },
];

const now = Date.now();
const hoursAgo = n => new Date(now - n * 60 * 60 * 1000).toISOString();
const hoursAhead = n => new Date(now + n * 60 * 60 * 1000).toISOString();
const daysAhead = n => new Date(now + n * 24 * 60 * 60 * 1000).toISOString();

const seedRequests = () => [
  {
    id: 'REQ-1042',
    memberName: 'Virtus Member',
    memberDisplayFirst: 'Jordan',
    clubId: 'vc-pebble-shore',
    clubName: 'Pebble Shore Country Club',
    preferredDate: daysAhead(4).slice(0, 10),
    window: { from: '08:00', to: '10:30' },
    choices: [
      { rank: 1, date: daysAhead(4).slice(0, 10), time: '08:12' },
      { rank: 2, date: daysAhead(4).slice(0, 10), time: '09:24' },
      { rank: 3, date: daysAhead(4).slice(0, 10), time: '10:18' },
    ],
    flex: { anyTimeInWindow: true, anyDayThisWeek: false },
    partySize: 4,
    notes: 'Guest from out of town — prefer later morning if possible.',
    status: RequestStatus.PendingClub,
    createdAt: hoursAgo(3),
    expiresAt: hoursAhead(21),
    acceptedOption: null,
    timeline: [
      { status: RequestStatus.Requested, at: hoursAgo(3), by: 'member' },
      {
        status: RequestStatus.PendingClub, at: hoursAgo(3), by: 'system', note: 'Concierge email dispatched',
      },
    ],
    communications: [
      {
        at: hoursAgo(3), channel: 'email', direction: 'out', subject: 'Virtus Member tee time request — Pebble Shore', target: 'teesheet@pebbleshore.example',
      },
    ],
  },
  {
    id: 'REQ-1041',
    memberName: 'Virtus Member',
    memberDisplayFirst: 'Jordan',
    clubId: 'vc-laurel-canyon',
    clubName: 'Laurel Canyon Golf Reserve',
    preferredDate: daysAhead(7).slice(0, 10),
    window: { from: '13:00', to: '15:00' },
    choices: [
      { rank: 1, date: daysAhead(7).slice(0, 10), time: '13:06' },
      { rank: 2, date: daysAhead(7).slice(0, 10), time: '13:54' },
      { rank: 3, date: daysAhead(7).slice(0, 10), time: '14:42' },
    ],
    flex: { anyTimeInWindow: false, anyDayThisWeek: true },
    partySize: 2,
    notes: '',
    status: RequestStatus.Accepted,
    createdAt: hoursAgo(30),
    expiresAt: hoursAhead(-6),
    acceptedOption: 2,
    timeline: [
      { status: RequestStatus.Requested, at: hoursAgo(30), by: 'member' },
      {
        status: RequestStatus.PendingClub, at: hoursAgo(30), by: 'system', note: 'Concierge email dispatched',
      },
      {
        status: RequestStatus.Accepted, at: hoursAgo(26), by: 'club', note: 'Club selected Option 2',
      },
    ],
    communications: [
      {
        at: hoursAgo(30), channel: 'email', direction: 'out', subject: 'Virtus Member tee time request — Laurel Canyon', target: 'pro.shop@laurelcanyon.example',
      },
      {
        at: hoursAgo(26), channel: 'web', direction: 'in', subject: 'Club selected Option 2', target: 'acceptance link',
      },
    ],
  },
];

// Member texts to the concierge desk: a simple message + its reply. Seeded so
// "My Messages" has history out of the box; new sends from the modal append here.
const seedMessages = () => [
  {
    id: 'MSG-1002',
    body: 'Bringing two guests to the home course on Sunday — can you arrange buggies and a halfway-house booking?',
    sentAt: hoursAgo(6),
    reply: {
      body: 'Done ✓ Two buggies reserved for Sunday and the halfway house is expecting your group at the turn. Anything else, just shout.',
      at: hoursAgo(5),
      read: true,
    },
  },
  {
    id: 'MSG-1001',
    body: 'Hi — any chance of a 4-ball at Pebble Shore this Saturday morning? Flexible on the exact time.',
    sentAt: hoursAgo(28),
    reply: {
      body: "All sorted ✓ Pebble Shore can do Saturday 09:24 for four players. You'll find the confirmation under My Requests — enjoy the round!",
      at: hoursAgo(26),
      read: true,
    },
  },
  {
    id: 'MSG-1000',
    body: 'Could you find me a quiet weekday twilight slot somewhere coastal next week?',
    sentAt: hoursAgo(50),
    reply: {
      body: 'Of course — Horizon Dunes has space Wednesday from 17:10. Want me to hold it for you?',
      at: hoursAgo(48),
      read: true,
    },
  },
];

// Ancillary-charge invoices the member receives (mirrors the admintools billing side).
// One outstanding invoice the member can settle (aligned £95.50 with the admin INV-2001),
// plus one already-paid for history.
const seedMemberInvoices = () => [
  {
    id: 'INV-2001',
    invoiceNumber: 'VG-2026-0001',
    partnerName: 'Pebble Shore Country Club',
    lineItems: [
      { type: 'food-beverage', description: 'Clubhouse lunch · party of 2', amount: 45.50 },
      { type: 'cart', description: 'Golf cart hire · 18 holes', amount: 30.00 },
      { type: 'caddy', description: 'Caddy fee', amount: 20.00 },
    ],
    total: 95.50,
    currency: 'GBP',
    issuedAt: hoursAgo(4 * 24),
    dueAt: hoursAhead(10 * 24),
    status: 'Outstanding',
    paidAt: null,
  },
  {
    id: 'INV-1998',
    invoiceNumber: 'VG-2025-0048',
    partnerName: 'Laurel Canyon Golf Reserve',
    lineItems: [
      { type: 'food-beverage', description: 'Halfway house · drinks', amount: 18.00 },
      { type: 'cart', description: 'Golf cart hire · 18 holes', amount: 30.00 },
    ],
    total: 48.00,
    currency: 'GBP',
    issuedAt: hoursAgo(40 * 24),
    dueAt: hoursAgo(26 * 24),
    status: 'Paid',
    paidAt: hoursAgo(34 * 24),
  },
];

const seedAcceptanceTokens = (requests) => {
  const map = {};
  requests
    .filter(r => r.status === RequestStatus.PendingClub)
    .forEach((r) => {
      map[`tok-${r.id.toLowerCase()}`] = {
        requestId: r.id,
        expiresAt: r.expiresAt,
        consumed: false,
        memberName: r.memberName,
      };
    });
  return map;
};

const defaultRulesMatrix = () => {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const slots = ['07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'];
  const matrix = {};
  days.forEach((d) => {
    matrix[d] = {};
    slots.forEach((s) => {
      const weekend = d === 'Sat' || d === 'Sun';
      const morning = s <= '10:00';
      if (weekend && morning) matrix[d][s] = 'Request';
      else if (weekend) matrix[d][s] = 'Available';
      else matrix[d][s] = 'Available';
    });
  });
  return {
    days, slots, cells: matrix, bookingWindowDays: 14,
  };
};

export {
  requestClubs,
  seedRequests,
  seedMessages,
  seedMemberInvoices,
  seedAcceptanceTokens,
  defaultRulesMatrix,
};
